import { Component, effect, input, model, output } from '@angular/core';
import { Drawer } from 'primeng/drawer';
import { XClose } from '../../../../infrastructure/shared/icons/x-close/x-close';
import { AppointmentDetailsContent } from '../../appointment-details-content/appointment-details-content';

@Component({
  standalone: true,
  selector: 'app-appointment-details-drawer',
  imports: [Drawer, XClose, AppointmentDetailsContent],
  templateUrl: './appointment-details-drawer.html',
  styleUrl: './appointment-details-drawer.scss',
})
export class AppointmentDetailsDrawer {
  visible = model<boolean>(false);
  appointmentId = input<string | undefined>(undefined);

  onCancel = output<string>();
  onRescheduled = output<string>();
  onMarkedNoShow = output<string>();

  /** Cleared id when drawer closes so the content effect drops cached details. */
  currentId: string | undefined;

  constructor() {
    effect(() => {
      const id = this.appointmentId();
      const isOpen = this.visible();
      this.currentId = isOpen ? id : undefined;
    });
  }

  close() {
    this.visible.set(false);
  }

  handleCancel(id: string) {
    this.onCancel.emit(id);
  }

  handleRescheduled(id: string) {
    this.onRescheduled.emit(id);
  }

  handleMarkedNoShow(id: string) {
    this.onMarkedNoShow.emit(id);
  }
}
